<template>
  <div class="Home">
    <HomeHeader />
    <!-- <OtheHeader /> -->
    <!-- <div class="line"></div> -->
    <div class="HomeContent">
      <div class="body">
        <div class="home_one">
          <!-- <router-link to="Case"> -->
          <div class="anli" @click="toCase">
            <img src="../assets/img/anli.png" alt class="img" />
            <div class="text">
              <p class="text_ch">行业/案例</p>
              <p class="text_en">Industry/Case</p>
            </div>
          </div>
          <!-- </router-link> -->
          <!-- <router-link to="Product"> -->
          <div class="chanpin" @click="toProduct">
            <div class="bagImg">
              <img src="../assets/img/chanpin.png" alt class="img" />
              <!-- <img v-if="chanpinImg == 1920" src="../assets/img/chanpin1920.png" alt class="img" />
              <img v-else-if="chanpinImg == 1366" src="../assets/img/chanpin1366.png" alt class="img" />
              <img v-else src="../assets/img/chanpin1280.png" alt class="img" /> -->
            </div>
            <div class="text">
              <p class="text_ch">产品</p>
              <p class="text_en">Products</p>
            </div>
          </div>
          <!-- </router-link> -->
        </div>
        <div class="home_two">
          <router-link to="Customized">
            <div class="home_two_bag dingzhi">
              <img src="../assets/img/fuwu.png" alt class="img" />
              <div class="text">
                <p class="text_en">服务/定制</p>
                <p class="text_en">Service/Custom-made</p>
              </div>
            </div>
          </router-link>
          <router-link to="Journalism">
            <div class="home_two_bag xinwen">
              <div class="bagImg">
                <img src="../assets/img/xinwen.png" alt class="img" />
              </div>
              <div class="text">
                <p class="text_en">新闻</p>
                <p class="text_en">News</p>
              </div>
            </div>
          </router-link>
          <router-link to="AboutUs">
            <div class="home_two_bag women">
              <img src="../assets/img/guanyu.png" alt class="img" />
              <div class="text">
                <p class="text_en">关于我们</p>
                <p class="text_en">About us</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <p class="title" style="margin-top:110px">生产</p>
      <p style="font-size:18px; color:rgba(199,196,196,1); text-align: center;">
        <span>Production</span>
      </p>
      <div class="hone_three">
        <el-carousel trigger="click" :interval="3500" style="height: 380px;">
          <el-carousel-item style="height: 380px;">
            <div class="img_bag">
              <div class="bag_item">
                <img :src="Production[0].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[0].title}}</h1>
                <p style="text-align: center;">{{Production[0].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[1].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[1].title}}</h1>
                <p style="text-align: center;">{{Production[1].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[2].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[2].title}}</h1>
                <p style="text-align: center;">{{Production[2].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[3].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[3].title}}</h1>
                <p style="text-align: center;">{{Production[3].dec}}</p>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item style="height: 380px;">
            <div class="img_bag">
              <div class="bag_item">
                <img :src="Production[4].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[4].title}}</h1>
                <p style="text-align: center;">{{Production[4].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[5].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[5].title}}</h1>
                <p style="text-align: center;">{{Production[5].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[6].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[6].title}}</h1>
                <p style="text-align: center;">{{Production[6].dec}}</p>
              </div>
              <div class="bag_item">
                <img :src="Production[7].img" alt class="img" />
                <h1 style="text-align: center;">{{Production[7].title}}</h1>
                <p style="text-align: center;">{{Production[7].dec}}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <p class="title" style="margin-top:80px;">认证</p>
      <p style="font-size:18px; color:rgba(199,196,196,1); text-align: center;">
        <span>Proven</span>
      </p>
      <div class="hone_four">
        <img src="https://www.line-found.com/image/gaoqi.png" alt class="img" />
        <img src="../assets/img/shouye5.png" alt class="img" />
        <img src="../assets/img/shouye6.png" alt class="img" />
        <img src="../assets/img/shouye7.png" alt class="img" />
        <img src="../assets/img/shouye8.png" alt class="img" />
      </div>
      <div class="colour">
        <div class="colourBag">
          <p class="title" style>伙伴</p>
          <p
            style="font-size:18px; color:rgba(199,196,196,1); text-align: center; margin-bottom:50px;"
          >
            <span>Partner</span>
          </p>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in colourList" :key="item.id">
                <img :src="'http://develop.line-found.com/' + item.image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import HomeHeader from "@/components/HomeHeader.vue";
// import OtheHeader from "@/components/OtheHeader.vue"
import Footer from "@/components/Footer.vue";

import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  name: "Home",
  components: {
    HomeHeader,
    // OtheHeader,
    Footer
  },
  data() {
    return {
      colourList: [],
      Production: [
        {
          title: "固晶",
          dec: "满足8寸晶圆盘",
          img: require("../assets/img/shouye1.png")
        },
        {
          title: "COB",
          dec: "铝线绑定，量产稳定",
          img: require("../assets/img/shouye2.png")
        },
        {
          title: "点胶",
          dec: "全自动点胶精致美观",
          img: require("../assets/img/shouye3.png")
        },
        {
          title: "Encoding",
          dec: "写码-检测一体化",
          img: require("../assets/img/shouye4.png")
        },
        {
          title: "超声波",
          dec: "各类外壳结构",
          img: require("../assets/img/shouye9.png")
        },
        {
          title: "SMT",
          dec: "贴片工艺，高温首选",
          img: require("../assets/img/shouye10.png")
        },
        {
          title: "检测仪",
          dec: "研发测试，标配暗箱",
          img: require("../assets/img/shouye11.png")
        },
        {
          title: "Laser",
          dec: "个性编码，长效清晰",
          img: require("../assets/img/shouye12.png")
        }
      ],
      chanpinImg: ''
    };
  },
  computed: {},
  created() {
    this.getFriendshipLinks();
  },
  methods: {
    toCase() {
      this.$router.push("/case");
    },
    toProduct() {
      this.$router.push("/product");
    },
    getFriendshipLinks() {
      this.fetchGet("index/friendshipLinks")
        .then(res => {
          this.colourList = res.data;
          this.$nextTick(() => {
            let mySwiper = new Swiper(".swiper-container", {
              slidesPerView: 5,
              spaceBetween: 30,
              autoplay: {
                delay: 1500,
                disableOnInteraction: false
              }
            });
            console.log(mySwiper);
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    if (document.documentElement.clientWidth > 1920) {
      this.chanpinImg = 1920
    } else if (document.documentElement.clientWidth > 1366 && document.documentElement.clientWidth < 1920) {
      this.chanpinImg = 1366
    } else {
      this.chanpinImg = 1280
    }
    console.log(this.chanpinImg)
  }
};
</script>
<style scoped lang="less">
.HomeContent {
  min-height: 1000px;
  .title {
    text-align: center;
    font-size: 28px;
    font-weight: 500;
  }
  .text {
    .text_ch {
      color: #111111;
      font-size: 36px;
      text-align: right;
    }
    .text_en {
      color: #111111;
      font-size: 26px;
      text-align: right;
    }
  }
  .body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(~"100vh - 62px");
  }
  .home_one {
    display: flex;
    height: 60%;
    // width: 70%
    // background-color: red;
    // overflow: hidden;
    margin-top: 10px;
    .text {
      position: absolute;
      top: 6%;
      right: 6%;
    }
    .anli {
      width: 50%;
      overflow: hidden;
      // background-image: url(../assets/img/anli.png);
      // width: 50%;
      // height: 960px;
      position: relative;
      .img {
        height: 100%;
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        transition: transform 1s;
        // width: auto;
        // height: auto;
        // max-width: 100%;
      }
      .img:hover {
        transform: scale(1.1, 1.1);
      }
    }
    .chanpin {
      width: 50%;
      overflow: hidden;
      // width: 50%;
      // height: 960px;
      // float: left;
      position: relative;
      .bagImg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #97E3EF;
        .img {
          box-sizing: border-box;
          transition: transform 1s;
          // width: 100%;
          height: 400px;
        }
        .img:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }
  }
  .home_two {
    // display: flex;
    height: 40%;
    // width: 40%;
    overflow: hidden;
    .home_two_bag {
      height: 100%;
      // flex-grow: 1;
      // height: 640px;
      float: left;
      position: relative;
      .text {
        .text_ch {
          font-size: 36px;
        }
        .text_en {
          font-size: 28px;
        }
      }
    }
    .dingzhi {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 33.33%;
      background-color: #a8bbbe;
      overflow: hidden;
      background-color: rgb(183, 179, 179);
      .img {
        width: auto;
        height: 80%;
        box-sizing: border-box;
        transition: transform 1s;
        // position: absolute;
        // bottom: 12%;
        // left: 11%
      }
      .img:hover {
        transform: scale(1.1, 1.1);
      }
      .text {
        position: absolute;
        top: 8%;
        left: 5%;
        .text_ch {
          text-align: left;
        }
        .text_en {
          text-align: left;
        }
      }
      .text_ch {
        color: #ffffff;
      }
      .text_en {
        color: #ffffff;
      }
    }
    .xinwen {
      width: 33.33%;
      overflow: hidden;
      .bagImg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgb(107, 189, 133);
        .img {
          width: 100%;
          // height: 100%;
          box-sizing: border-box;
          transition: transform 1s;
          // position: absolute;
          // bottom: 0;
          // left: 0
        }
        .img:hover {
          transform: scale(1.1, 1.1);
        }
      }
      .text {
        position: absolute;
        top: 8%;
        right: 5%;
      }
      .text_ch {
        color: #ffffff;
      }
      .text_en {
        color: #ffffff;
      }
    }
    .women {
      width: 33.33%;
      background-color: #b6c0ca;
      overflow: hidden;
      background-color: rgb(236, 236, 236);
      .img {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        transition: transform 1s;
        position: absolute;
        bottom: -9%;
        left: 0;
      }
      .img:hover {
        transform: scale(1.1, 1.1);
      }
      .text {
        position: absolute;
        top: 8%;
        right: 5%;
        // .text_ch {
        //   color: #ffffff;
        // }
        // .text_en {
        //   color: #ffffff;
        // }
      }
    }
  }
  .hone_three {
    width: 1200px;
    margin: 50px auto 0;
    .img_bag {
      display: flex;
      justify-content: space-between;
      .bag_item {
        width: 300px;
        height: 280px;
        // overflow: hidden;
        .img {
          width: 280px;
          height: 280px;
          box-sizing: border-box;
          transition: transform 1s;
          margin-bottom: 10px;
          box-shadow: 0px 5px 10px #888888;
        }
        .img:hover {
          transform: scale(1.1, 1.1);
        }
      }
    }
  }
  .hone_four {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1480px;
    height: 267px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.08);
    margin: 50px auto 0;
    padding: 0 184px;
    box-sizing: border-box;
    margin-bottom: 90px;
    .img {
      width: auto;
      height: 125px;
    }
  }
  .colour {
    // height: 320px;
    width: 100%;
    background-color: #f7f6f9;
    .colourBag {
      padding: 85px 0;
      box-sizing: border-box;
      width: 1200px;
      margin: 50px auto 10px;
    }
    .swiper-wrapper {
      height: 170px;
    }
    .swiper-slide {
      width: 24px;
      height: 160px;
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      img {
        max-width: 210px;
        // max-height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
// .swiper-container {
//     width: 600px;
//     height: 300px;
//     border: 1px solid #E5E5E5;
// }
</style>
